"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.generalHelpers = void 0;
const constants_1 = require("./constants");
class GeneralHelpers {
  FormatDate = date => {
    return date.toISOString().split('T')[0];
  };
  GetCalendarWeekCount = year => {
    const jan1 = new Date(year, 0, 1);
    jan1.setHours(0, 0, 0, 0);
    const dec31 = new Date(year, 11, 31);
    dec31.setHours(0, 0, 0, 0);
    const firstSunday = new Date(jan1);
    firstSunday.setDate(jan1.getDate() + (7 - jan1.getDay()) % 7);
    const lastSunday = new Date(dec31);
    lastSunday.setDate(dec31.getDate() - dec31.getDay());
    const diffDays = (lastSunday.getTime() - firstSunday.getTime()) / constants_1.millisecondsOneDay;
    const weekCount = 1 + Math.floor(diffDays / 7);
    return weekCount;
  };
  GetCalendarWeekNumber = date => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    const day = d.getDay();
    const sunday = new Date(d);
    sunday.setDate(d.getDate() + (7 - day) % 7);
    const year = sunday.getFullYear();
    const jan1 = new Date(year, 0, 1);
    jan1.setHours(0, 0, 0, 0);
    const firstSunday = new Date(jan1);
    firstSunday.setDate(jan1.getDate() + (7 - jan1.getDay()) % 7);
    const diffDays = Math.floor((sunday.getTime() - firstSunday.getTime()) / constants_1.millisecondsOneDay);
    const weekNumber = 1 + Math.floor(diffDays / 7);
    return weekNumber;
  };
  GetCurrentLocalDate = (invert = false) => {
    const argDate = new Date();
    argDate.setTime(argDate.getTime() - constants_1.millisecondsThreeHours);
    const date = argDate.toISOString().split('T')[0];
    if (invert) {
      return this.InvertDateString(date);
    }
    return date;
  };
  GetDateFromDateString = date => {
    return new Date(parseInt(date.split('-')[0]), parseInt(date.split('-')[1]) - 1, parseInt(date.split('-')[2]));
  };
  GetDateStringFromDate = date => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };
  GetDaysOfMonth = (month, year) => {
    return new Date(year, month + 1, 0).getDate();
  };
  GetLinkForHthUniqueAccess = (origin, congregation, territoryNumber) => {
    return `${origin}/buscador/${congregation}/${territoryNumber}`; // usingLettersForBlocks
  };
  GetLinkTextForHthActivityFeedback = (origin, congregation, serviceId, completionDate, usingLettersForBlocks) => {
    // TODO: remove querystring and get config from backend
    let text = '';
    text += `Por favor, *ingresar en el siguiente enlace y marcar los territorios abarcados durante el servicio de hoy*:`;
    text += '\n\n`';
    text += `${origin}/actividad/${congregation}/${serviceId}/${completionDate}${usingLettersForBlocks ? '?ulfb=true' : ''}`;
    text += '`\n\n';
    text += `Si la actividad no se realizó, desestimar este mensaje. Muchas gracias!`;
    return text;
  };
  GetLinkTextForHthUniqueAccess = (origin, congregation, congregationName, territoryNumber) => {
    let text = `*Congregación ${congregationName}*`;
    text += `\n\n`;
    text += `Acceso al *Territorio ${territoryNumber}* para el día ${exports.generalHelpers.GetCurrentLocalDate()}:`;
    text += `\n\n`;
    text += '`';
    text += this.GetLinkForHthUniqueAccess(origin, congregation, territoryNumber);
    text += '`';
    return text;
  };
  GetPublicMinistryServicesByDay = monthlyService => {
    const services = Array.from({
      length: this.GetDaysOfMonth(monthlyService.month, monthlyService.year)
    }, (_, i) => i + 1).map(d => {
      const weekday = new Date(monthlyService.year, monthlyService.month, d).getDay();
      const fromThisDate = monthlyService.services.filter(s => s.day === d);
      const fromThisWeekday = monthlyService.services.filter(s => s.weekday === weekday);
      const services = [];
      if (fromThisDate.length) {
        services.push(...fromThisDate);
      } else if (fromThisWeekday.length) {
        services.push(...fromThisWeekday);
      }
      services.sort((s1, s2) => s1.hour - s2.hour || s1.minutes - s2.minutes);
      return {
        day: d,
        services
      };
    });
    return services;
  };
  GetTimeFromPeriodObject = (period, mode = 1) => {
    const startHour = period.startHour?.toString().padStart(2, '0');
    const startMinutes = period.startMinutes?.toString().padStart(2, '0');
    const endHour = period.endHour?.toString().padStart(2, '0');
    const endMinutes = period.endMinutes?.toString().padStart(2, '0');
    return mode === 1 ? `${startHour}:${startMinutes}-${endHour}:${endMinutes}` : `desde las ${startHour}:${startMinutes} hs. hasta las ${endHour}:${endMinutes} hs.`;
  };
  InvertDateString = dateString => {
    const a = dateString.split('-');
    return `${a[2]}-${a[1]}-${a[0]}`;
  };
  IsToday = timestamp => {
    const argDate = new Date(timestamp);
    argDate.setTime(argDate.getTime() - constants_1.millisecondsThreeHours);
    // const argDate = new Date(timestamp - millisecondsThreeHours);  better?
    const currentLocalDateFromTimestamp = argDate.toISOString().split('T')[0];
    return currentLocalDateFromTimestamp === this.GetCurrentLocalDate();
  };
  IsValidEmail = email => {
    return constants_1.emailPattern.test(email);
  };
  IsValidPhoneNumber = phoneNumber => {
    return constants_1.phoneE164Pattern.test(phoneNumber);
  };
  NormalizeEmailAddress = email => {
    return email.trim().toLowerCase();
  };
}
exports.generalHelpers = new GeneralHelpers();